<!--
 * @Author: your name
 * @Date: 2020-11-17 14:59:41
 * @LastEditTime: 2020-11-17 15:31:22
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \no_reject\src\App.vue
-->
<template>
  <div id="app">
    <component :is="layout" :class="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
export default {
  computed: {
    getMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? "mobile" : "pc";
      return layout;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue